export interface IAPUserModeConfig {
  isAdvisor: () => boolean;
  isStudent: () => boolean;
}
export class APUserModeConfig implements IAPUserModeConfig {
  constructor(private $state: ng.ui.IStateService) {}

  isAdvisor() {
    return this.$state.includes('ap-advisor');
  }
  isStudent() {
    return !this.isAdvisor();
  }
}
angular.module('capability-ng-academic-planner').service('ngAPUserModeConfig', APUserModeConfig);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/user_mode_config/config/ap_user_mode_config.ts